import { Box, Toast, useToast as useNotificationToast } from '@chakra-ui/react';
import React from 'react';

export interface UseToastConfig {
  defaultErrorText?: string;
}

const useToast = (config?: UseToastConfig) => {
  const toast = useNotificationToast();
  const { defaultErrorText = 'An error occurred' } = config || {};

  const showErrorToast = (title?: string, description?: string) => {
    toast({
      title: title || defaultErrorText,
      description,
      status: 'error',
      duration: 4000,
      isClosable: true,
      containerStyle: {
        w: 'full',
        px: 'xs',
      },
      render: (props) => (
        <Box data-testid='error-toast'>
          <Toast
            {...props}
            width='full'
          />
        </Box>
      ),
    });
  };

  const showSuccessToast = (title?: string, description?: string) => {
    toast({
      title,
      description,
      status: 'success',
      duration: 4000,
      isClosable: true,
      containerStyle: {
        w: 'full',
        px: 'xs',
      },
      render: (props) => (
        <Box data-testid='success-toast'>
          <Toast
            {...props}
            width='full'
          />
        </Box>
      ),
    });
  };

  const showInfoToast = (title?: string, description?: string) => {
    toast({
      title,
      description,
      status: 'info',
      duration: 4000,
      isClosable: true,
      containerStyle: {
        w: 'full',
        px: 'xs',
      },
      render: (props) => (
        <Box data-testid='info-toast'>
          <Toast
            {...props}
            width='full'
          />
        </Box>
      ),
    });
  };

  const showWarningToast = (title?: string, description?: string) => {
    toast({
      title,
      description,
      status: 'warning',
      duration: 4000,
      isClosable: true,
      variant: 'warning',
      containerStyle: {
        w: 'full',
        px: 'xs',
      },
      render: (props) => (
        <Box data-testid='warn-toast'>
          <Toast
            {...props}
            width='full'
          />
        </Box>
      ),
    });
  };

  return {
    showErrorToast,
    showSuccessToast,
    showInfoToast,
    showWarningToast,
  };
};

export default useToast;
